export const HandleInput = (event)=>{
    
    if(event.key === "-"){
        event.preventDefault();
    }
}
